import Translate from "../../../components/Translate";
import {Link} from "react-router-dom";
import React from "react";

export default function MenuContabilita({
                                            isRuoloAdmin,
                                            isRuoloSegreteria,
                                        }) {

    return (isRuoloAdmin() || isRuoloSegreteria()) &&
        <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="contabilita"
               role="button"
               data-bs-toggle="dropdown" aria-expanded="false">
                <i className="fas fa-credit-card"/>
                <Translate>Contabilità</Translate>
            </a>
            <ul className="dropdown-menu" aria-labelledby="contabilita">
                <li>
                    <Link to="/list-movimenti" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="far fa-credit-card"/>
                            <Translate>Movimenti</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-transazioni" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-credit-card-alt"/>
                            <Translate>Transazioni</Translate>
                        </div>
                    </Link>
                </li>
            </ul>
        </li>
}